<template>
  <div id="select-wrapper" ref="select-wrapper" v-click-outside="closeDropdown">
    <label v-html="label" v-if="label"></label>
    <div class="selected-item" ref="select-item" @click="toggleDropdown">
      <div class="selected-element">
        {{
          selected && selected.value !== undefined
            ? selected.text
            : placeholderText
        }}
      </div>
      <div class="icon" ref="icon">
        <img src="/static/icons/toggle-icon.svg" />
      </div>
    </div>
    <div class="selectable-items custom-scrollbar" ref="selectable-items">
      <div class="items">
        <basic-select-item
          :value="undefined"
          v-if="selected && selected.value !== undefined"
          :text="$t('basicSelect.setToUndefined')"
        />
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasicSelect",
  props: {
    width: {
      type: String,
      required: false,
      default: "100%"
    },
    label: {
      type: String,
      required: false,
      default: undefined
    },
    placeholderText: {
      type: String,
      required: false,
      default: undefined
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      required: false,
      default: undefined
    }
  },
  data() {
    return {
      expanded: false,
      selected: undefined,
      default: this.value
    };
  },
  mounted() {
    this.$refs["select-wrapper"].style.width = this.width;
  },
  methods: {
    calculateDropDownHeight() {
      const length = this.$children.length > 5 ? 5 : this.$children.length;
      const height = length * 45;
      const toHeight = this.expanded ? height : 0;
      return toHeight;
    },
    openDropdown() {
      this.expanded = true;
      setTimeout(() => {
        const tl = this.$anime.timeline();
        tl.add({
          targets: this.$refs["selectable-items"],
          duration: 700,
          easing: "easeOutExpo",
          scale: [0, 1],
          opacity: 1
        });
      }, 100);
    },
    closeDropdown() {
      this.$anime.timeline().add({
        targets: this.$refs["selectable-items"],
        duration: 700,
        easing: "easeOutExpo",
        scale: [1, 0],
        opacity: 0,
        complete: () => {
          this.expanded = false;
        }
      });
    },
    toggleDropdown() {
      if (!this.disabled) {
        if (this.expanded) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }
    }
  },
  watch: {
    value() {
      this.default = this.value;
      if (this.value === undefined) {
        this.selected = undefined;
      }
    },
    selected() {
      if (this.selected) {
        this.$emit("input", this.selected.value);
      } else {
        this.$emit("input", this.selected);
      }
      // this.closeDropdown();
    },
    expanded() {
      if (!this.expanded) {
        this.$refs["select-item"].classList.remove("active");
        this.$refs["icon"].classList.remove("rotated");
        this.$refs["selectable-items"].style.height = "0";
      } else {
        setTimeout(() => {
          this.$refs["select-item"].classList.add("active");
          this.$refs["icon"].classList.add("rotated");
          this.$refs["selectable-items"].style.height = "unset";
          this.$refs["selectable-items"].style.top =
            0 - this.calculateDropDownHeight() / 2 + 45 / 2 + "px";
        }, 100);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#select-wrapper {
  position: relative;
  label {
    padding-left: 5px;
    font-size: 13px;
    margin: 0;
  }
  .selected-item {
    cursor: pointer;
    width: 100%;
    height: 40px;
    border: 1px solid#adadad;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    &.active {
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15) !important;
      border: 1px solid $color-primary !important;
    }
    .selected-element {
      margin-left: 10px;
      font-size: 14px;
      // font-weight: 450;
    }
    .icon {
      display: flex;
      transition: 0.3s all ease-in-out;
      margin-right: 10px;
      transform: rotate(-180deg);
      height: 15px;
      &.rotated {
        transform: rotate(0);
      }
      img {
        height: 100%;
      }
    }
  }
  .selectable-items {
    width: 100%;
    height: 0;
    position: absolute;
    max-height: 225px;
    box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.2);
    background: white;
    border-radius: 8px;
    z-index: 1;
    opacity: 0;
  }
}
</style>
